<template>
  <aside class="Senior_service">
    <div class="title">中学服务</div>
    <div class="content">
      <div class="top">
        <figure></figure>
        <p>仅2009至2014年全国普通高等学校统一招考的不完全统计数据，50余名优能学员勇夺省、市状元、榜眼称号，数千名学员被北京大学、清华大学、浙江大学、复旦大学、香港大学等多所知名高等学府录取，高考总分600分以上学员书万名，数学、理综、英语、语文、文综单科高分学员更是多达数十万人。学员的成功就是我们的成功，必然离不开我们优秀的教师资源和完整的教学体系。</p>
        <p>
          </p><h3>名师百炼成钢 &gt;&gt;</h3>
          <div>师出名门—1年培训—拓展集训—9人精选</div>
          <div>8轮面试—4级强化—每周集体备课</div>
         <p></p>
         <p>
          </p><h3>课程精挑细选 &gt;&gt;</h3>
          <div>科目全面—课程目标清晰—一对一私教</div>
          <div>难易相成—方法难点击破—特色班级</div>
         <p></p>

      </div>
      <dl class="bottom">
        <dt class="floatL"></dt>
        <dd class="floatR">
          <p>
            <a href="">课堂教学的补充提高</a>
          </p>
          <p>VPS(进步可视教学体系)学习改变命运，这次改变学习</p>
        </dd>
      </dl>
      <dl class="bottom" style="border-bottom: 0">
        <dt class="floatL"></dt>
        <dd class="floatR">
          <p>
            <a href="">优能一对一</a>
          </p>
          <p>专注于一对一教学，学院普遍提分30-50分</p>
        </dd>
      </dl>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'Introduce',
  data () {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
.Senior_service
  width: 270px
  margin-top: 0
  height: 100%
  float: right
  border: 1px solid #e1e2e1
  .title
    height: 34px
    line-height: 34px
    font-size: 18px
    background: #f9fafb
    padding-left: 20px
    border-bottom: 1px solid #e1e2e1
  .content
    padding: 6px
    .top
      color: #707070
      line-height: 24px
      padding: 12px
      border-bottom: 1px dashed #e5e5e5
      figure
        height: 46px
        background: url(http://images.xdf.cn/school/middleschool/static/images/youneng.png) no-repeat center center
        margin: 16px
    .bottom
      float: left
      width: 100%
      height: 53px
      padding: 22px 0 18px 0
      border-bottom: 1px dashed #e5e5e5
      .floatL
        float: left
        height: 52px
        width: 90px
        border-right: 1px solid #e0e0e0
        background: url(http://images.xdf.cn/school/middleschool/static/images/vps_img.png) no-repeat
      .floatR
        float: right
        height: 56px
        width: 154px
        margin-top: -7px
        p
          color: #999999
          line-height: 18px
          font-size: 12px
          a
            color: #4a4a4a
            line-height: 24px
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Introduce.vue